import email from '../assets/email.png';
import mobile from '../assets/mobile.png';
import api from '../assets/api.png';
import cpp from '../assets/cpp.png';
import css from '../assets/css.png';
import figma from '../assets/figma.png';
import flutter from '../assets/flutter.png';
import git from '../assets/git.png';
import graphql from '../assets/graphql.png';
import html from '../assets/html.png';
import javascript from '../assets/javascript.png';
import mu5 from '../assets/mu5.png';
import node from '../assets/node.png';
import python from '../assets/python.png';
import react from '../assets/react.png';
import redux from '../assets/redux.png';
import sass from '../assets/sass.png';
import typescript from '../assets/typescript.png';
import vue from '../assets/vue.png';
import Java from '../assets/Java.svg';
import Ethereum from '../assets/Ethereum.svg';
import Solidity from '../assets/Solidity.svg';
 

  
import circle from '../assets/circle.svg';
import scooljdot from '../assets/scoolj_dot_logo.png'
import unilagConsult from '../assets/unilag_consult.jpeg'
import adidas from '../assets/adidas.png';
import amazon from '../assets/amazon.png';
import asus from '../assets/asus.png';
import bolt from '../assets/bolt.png';
import nb from '../assets/nb.png';
import skype from '../assets/skype.png';
import spotify from '../assets/spotify.png';
import si_bg from '../assets/si_bg.png';
import si2 from '../assets/si.jpg';
import summer from '../assets/summer.png';
import boy from '../assets/boy.png';
import register from '../assets/register.png';
import apply from '../assets/apply.jpeg';
import headset from '../assets/headset.svg';
import bg1 from '../assets/bg1.jpg';
import bg2 from '../assets/bg2.jpeg';
import bg3 from '../assets/bg3.jpeg';
import bg4 from '../assets/bg4.jpeg';
import bg5 from '../assets/bg5.jpg';
import whatsapp from '../assets/whatsapp.svg';
import siunilag from '../assets/siunlag.jpeg';
import siunilag2 from '../assets/siunlag2.jpeg';
import founilag from '../assets/founilag.jpg';
import founilag2 from '../assets/founilag2.jpg';
import map from '../assets/map.svg';
import bp from '../assets/bp.png';
import drill from '../assets/drill.png';
import pdt from '../assets/pdt.png';
import sm from '../assets/sm.png';
import bomi from '../assets/bomi.jpg';
import gps from '../assets/gps.png';
import ura from '../assets/ura.png';
import dsa from '../assets/dsa.png';
import vital from '../assets/vital.png';
import aaif from '../assets/aaif.png';


// testimonial
import fikayo from '../assets/fikayo.jpg'
import osanyin from '../assets/osanyin.jpg'


const images = {
  email,
  mobile,
  api,
  cpp,
  css,
  figma,
  flutter,
  git,
  graphql,
  html,
  javascript,
  mu5,
  node,
  python,
  react,
  redux,
  sass,
  typescript,
  vue,
  circle,
  adidas,
  amazon,
  asus,
  bolt,
  nb,
  skype,
  spotify,
  si_bg,
  si2,
  summer,
  boy,
  Solidity,
  Java,
  Ethereum,
  register,
  apply,
  headset,
  bg1,
  bg2,
  bg3,
  bg4,
  bg5,
  whatsapp,
  siunilag,
  siunilag2,
  founilag,
  founilag2,
  map,
  fikayo,
  osanyin,
  scooljdot,
  unilagConsult,
  bp,
  sm,
  drill,
  pdt,
  bomi,
gps,
ura,
dsa,
vital,
aaif

};

export default images;
